import { useParams } from 'react-router-dom';
export const replacePlaceholderWithPortalId = (portalId, path) => path.replace(/\/l\//g, `/${portalId}/`);
export const useIsOnOwnProfile = () => {
  const {
    userId
  } = useParams();
  return !userId;
};